export const reviewsRoutes = [
  {
    path: '/reviews',
    name: 'Reviews',
    component: () =>
      import(
        /* webpackChunkName: "review" */ '@/views/Dashboard/Reviews/Reviews.vue'
      ),
  },
  {
    path: '/reviews/:id',
    name: 'ReviewDetail',
    component: () =>
      import(
        /* webpackChunkName: "reviewDetail" */ '@/views/Dashboard/Reviews/ReviewDetail.vue'
      ),
  },
];
